export const DOMAIN_REVENUE_AND_EXPENSES = "REVENUE_AND_EXPENSES";
